export interface PaginationHeaders {
  totalCount: number;
  totalPages: number;
  currentPage: number;
  nextPage: number | null;
  prevPage: number | null;
}

export function parsePaginationHeaders(headers: Headers): PaginationHeaders {
  return {
    totalCount: Number(headers.get("x-pager-total-count")) || 0,
    totalPages: Number(headers.get("x-pager-total-pages")) || 1,
    currentPage: Number(headers.get("x-pager-current-page")) || 1,
    nextPage: Number(headers.get("x-pager-next-page")) || null,
    prevPage: Number(headers.get("x-pager-prev-page")) || null,
  };
}
